module.exports = __webpack_public_path__ + "img/img_61284_0_8.af55b14e.png";